<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row">
  <div class="col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 text-center align-middle">
    <div class="row">
      <div class="col-6 col-sm-6 col-md-12 col-lg-12 col-xl-12 mb-3">
        <span class="badge badge-primary badge-circle">{{position}}</span>
      </div>

      <div class="col-6 col-sm-6 col-md-12 col-lg-12 col-xl-12 mb-3">
        <button class="btn btn-icon-only btn-lg" style="color: gold;" (click)="showFavorite()">
          <em class="la" [class.la-star]="isFavorite" [class.la-star-o]="!isFavorite"></em>
        </button>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 align-middle">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <app-display-removal-point-details [data]="data"></app-display-removal-point-details>
      </div>

      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-input-phone-numbers [removalPoint]="data" [allowAdd]="true" [allowRemove]="true"
                                     [index]="position" (updated)="updatePhones()"></app-input-phone-numbers>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
            <app-input-phone-numbers [removalPoint]="data" [allowAdd]="true" [allowRemove]="true" [index]="position"
                                     [mobilePhones]="true" (updated)="updatePhones()"></app-input-phone-numbers>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center align-middle">
    <div class="row">
      <div class="col-6 col-sm-6 col-md-12 col-lg-12 col-xl-12 mb-3">
        <button class="btn btn-icon-only btn-link btn-lg" (click)="showEditForm()"><em class="la la-edit"></em></button>
      </div>

      <div class="col-6 col-sm-6 col-md-12 col-lg-12 col-xl-12 mb-3">
     <!--   <bSwitch switch-off-color="danger"
                 switch-off-text="Disabled" switch-on-color="success" switch-on-text="Enabled" [ngModel]="data?.enabled"
                 switch-size="mini" (changeState)="changeState($event)"></bSwitch>
                 -->
        <mat-slide-toggle (change)="changeState($event)" [ngModel]="data?.enabled" color="custom" labelPosition="before">
          {{data?.enabled ? "Activé" : "Désactivé"}}
        </mat-slide-toggle>




      </div>
    </div>
  </div>
</div>
